import { Injectable } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { TextEditorHistoryService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-history.service';
import {
    AdvancedTextPanelPasteDialogComponent,
    IAdvancedTextPanelPasteDialogData,
} from '../advanced-text-panel/advanced-text-panel-paste-dialog/advanced-text-panel-paste-dialog.component';
import { FiDialogsService } from '../../fi-dialogs';
import { ITextPanelButton } from '../simple-text-panel/text-panel-base';

@Injectable()
export class AdvancedTextPanelBufferService {
    constructor(
        private appTextService: AppTextService,
        private textEditorHistoryService: TextEditorHistoryService,
        private fiDialogsService: FiDialogsService,
    ) {}

    private buffer: DocumentFragment;

    getButtons(): ITextPanelButton[] {
        return [
            {
                title: this.appTextService.get('text_editor.cut'),
                class: 'fas fa-cut',
                btnClass: 'BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    this.buffer = window.getSelection().getRangeAt(0).cloneContents();
                    document.execCommand('cut');
                },
            },
            {
                title: this.appTextService.get('copy'),
                class: 'fas fa-copy',
                btnClass: 'BrandedColorHover panel-icon-button',
                callback: () => {
                    this.buffer = window.getSelection().getRangeAt(0).cloneContents();
                    document.execCommand('copy');
                },
            },
            {
                title: this.appTextService.get('text_editor.paste'),
                class: 'fas fa-paste',
                btnClass: 'BrandedColorHover panel-icon-button',
                callback: () => {
                    const sel: Selection = window.getSelection();
                    const range: Range = sel.getRangeAt(0);

                    const dialogContentData: IAdvancedTextPanelPasteDialogData = {
                        messageText: this.appTextService.get('text_editor.no_clipboard_access_warning'),
                    };

                    this.fiDialogsService
                        .custom({
                            headerText: this.appTextService.get('dialog.header_confirm'),
                            contentComponentRef: AdvancedTextPanelPasteDialogComponent,
                            contentComponentData: dialogContentData,
                        })
                        .onYesButtonClick((dialogResult) => {
                            if (dialogResult) {
                                this.textEditorHistoryService.saveState();
                                range.deleteContents();
                                const node: HTMLElement = document.createElement('div');
                                node.innerHTML = dialogResult;
                                range.insertNode(node);
                                range.collapse(false);
                                sel.removeAllRanges();
                                sel.addRange(range);
                            }
                        });
                },
            },
        ];
    }
}
